//Constants file for art and photo projects

//Constant for ArtGallery.jsx
export const WELCOME_ART = "Welcome to my ";
export const ART_GALLERY = "Art Gallery";
export const ART_PROJECT = "Art Projects";
export const ART_INSTA = "Instagram";

//Constant for PhotoGallery.jsx
export const WELCOME_PHOTO = "Welcome to my ";
export const PHOTO_GALLERY = "Photo Gallery";
export const PHOTO_PROJECT = "Photo Projects";
export const PHOTO_INSTA = "Instagram";
